import { combineReducers } from "redux";
import authReducer from "./authSlice";
import sidebarReducer from "./sidebarSlice";
import { baseQuery } from "../../services/baseQuery";

const rootReducer = combineReducers({
  auth: authReducer,
  sidebar: sidebarReducer,
  [baseQuery.reducerPath]: baseQuery.reducer,
});

export default rootReducer;
